// Google Tag Manager integration
export const gtm = {
    pushEvent: (eventName, eventParams = {}) => {
        if (typeof window !== 'undefined' && window.dataLayer) {
            window.dataLayer.push({
                event: eventName,
                timestamp: new Date().toISOString(),
                ...eventParams,
            });
            console.log(`📊 GTM Event: ${eventName}`, eventParams);
        } else {
            console.warn('GTM dataLayer not available');
        }
    },

    // Enhanced event tracking with more context
    trackPageView: (page, title) => {
        gtm.pushEvent('page_view', {
            page_title: title || document.title,
            page_location: window.location.href,
            page_path: page || window.location.pathname,
        });
    },

    trackUserEngagement: (engagementType, details = {}) => {
        gtm.pushEvent('user_engagement', {
            engagement_type: engagementType,
            ...details
        });
    },

    trackFormSubmission: (formName, formData = {}) => {
        gtm.pushEvent('form_submit', {
            form_name: formName,
            form_location: window.location.pathname,
            ...formData
        });
    },

    trackButtonClick: (buttonName, buttonLocation) => {
        gtm.pushEvent('button_click', {
            button_name: buttonName,
            button_location: buttonLocation,
            page_location: window.location.pathname,
        });
    }
};

// Initialize GTM dataLayer if it doesn't exist
export const initGTM = (gtmId) => {
    if (typeof window !== 'undefined') {
        window.dataLayer = window.dataLayer || [];

        // GTM script injection
        if (gtmId && !document.querySelector(`script[src*="${gtmId}"]`)) {
            const script = document.createElement('script');
            script.async = true;
            script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
            document.head.appendChild(script);

            window.dataLayer.push({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js'
            });
        }
    }
};
